export type CanCheck = (...permissions: string[]) => boolean;

export interface DisputeProgress {
  pending: number;
  counted: number;
  disputed?: number;
}

export function isStockApprover(can: CanCheck): boolean {
  return can('stock.adjust.approve');
}

export function disputesVisible(sheet: { blind: boolean }, approver: boolean): boolean {
  return approver || !sheet.blind;
}

export function disputedOf(progress: DisputeProgress): number {
  return progress.disputed ?? 0;
}

export function disputesSavedBy(result: { saved: number; disputed?: number }): number {
  return result.disputed ?? 0;
}

export function shownLineStatus(status: string, showDisputes: boolean): string {
  return status === 'disputed' && !showDisputes ? 'counted' : status;
}

export function canResolveLine(approver: boolean, sheetOpen: boolean, lineStatus: string): boolean {
  return approver && sheetOpen && lineStatus === 'disputed';
}
